/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Contact_UsInputs */

const en_common_contact_us = /** @type {(inputs: Common_Contact_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Us`)
};

const es_common_contact_us = /** @type {(inputs: Common_Contact_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contáctanos`)
};

/**
* | output |
* | --- |
* | "Contact Us" |
*
* @param {Common_Contact_UsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_contact_us = /** @type {((inputs?: Common_Contact_UsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Contact_UsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_contact_us(inputs)
	return en_common_contact_us(inputs)
});